// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"694":"a4fe211c","36453":"8acfaa0b","71317":"d1a727b0"}[chunkId] + ".chunk.css";
};